// BASE_ID: "20260704A"

const DOMAIN_ROUTE_DEFINITIONS = [
  {
    hostname: "cmctrdr.com",
    aliases: ["www.cmctrdr.com"],
    verticalId: "comics",
    vertical: "comics",
    brand: "CMCTRDR",
    label: "Comic marketplace",
    defaultPath: "/",
    previewPath: null,
    status: "live",
    theme: {
      primary: "#2563eb",
      accent: "#facc15",
      surface: "#eff6ff",
    },
  },

  {
    hostname: "crdtrdr.com",
    aliases: ["www.crdtrdr.com", "cardtrdr.com", "www.cardtrdr.com"],
    verticalId: "cards",
    vertical: "cards",
    brand: "CRDTRDR",
    label: "Card marketplace umbrella",
    defaultPath: "/cards",
    previewPath: "/cards-preview",
    status: "preview",
    theme: {
      primary: "#1d4ed8",
      accent: "#f59e0b",
      surface: "#eef2ff",
    },
  },

  {
    hostname: "pkmntrdr.com",
    aliases: ["www.pkmntrdr.com"],
    verticalId: "pokemon",
    vertical: "cards",
    family: "tcg",
    game: "pokemon",
    brand: "PKMNTRDR",
    label: "Pokémon card marketplace",
    defaultPath: "/pokemon/marketplace",
    legacyDefaultPaths: ["/cards/tcg/pokemon", "/cards-preview/tcg/pokemon"],
    previewPath: "/cards-preview/tcg/pokemon",
    status: "preview",
    theme: {
      primary: "#dc2626",
      accent: "#facc15",
      surface: "#fff7ed",
    },
  },

  {
    hostname: "mtgtrdr.com",
    aliases: ["www.mtgtrdr.com"],
    verticalId: "magic",
    vertical: "cards",
    family: "tcg",
    game: "magic",
    brand: "MTGTRDR",
    label: "Magic card marketplace",
    defaultPath: "/cards/tcg/magic",
    previewPath: "/cards-preview/tcg",
    status: "future",
    theme: {
      primary: "#7c3aed",
      accent: "#f97316",
      surface: "#f5f3ff",
    },
  },

  {
    hostname: "ccgtrdr.com",
    aliases: ["www.ccgtrdr.com"],
    verticalId: "tcg",
    vertical: "cards",
    family: "tcg",
    brand: "CCGTRDR",
    label: "TCG / CCG marketplace",
    defaultPath: "/cards/tcg",
    previewPath: "/cards-preview/tcg",
    status: "preview",
    theme: {
      primary: "#0f766e",
      accent: "#f59e0b",
      surface: "#ecfeff",
    },
  },
];

export const domainRoutes = DOMAIN_ROUTE_DEFINITIONS.reduce((routes, definition) => {
  const { aliases = [], ...route } = definition;
  const hostnames = [definition.hostname, ...aliases];

  hostnames.forEach((hostname) => {
    routes[hostname] = route;
  });

  return routes;
}, {});

export const domainRoutePreviews = DOMAIN_ROUTE_DEFINITIONS.map(
  ({ aliases, ...definition }) => ({
    ...definition,
    aliases: aliases || [],
  })
);

export function normalizeHostname(hostname) {
  return String(hostname || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "")
    .replace(/:\d+$/, "");
}

export function getDomainRoute(hostname) {
  const normalizedHostname = normalizeHostname(hostname);
  return domainRoutes[normalizedHostname] || null;
}

export function getCurrentDomainRoute() {
  if (typeof window === "undefined") return null;
  return getDomainRoute(window.location.hostname);
}

export function getDomainPreviewRouteForHost(hostname) {
  const route = getDomainRoute(hostname);
  return route?.previewPath || route?.defaultPath || "/";
}

export function getCanonicalDomainRouteForVertical(verticalId) {
  const normalizedVerticalId = String(verticalId || "").trim();
  if (!normalizedVerticalId) return null;
  return domainRoutePreviews.find((route) => String(route.verticalId || "").trim() === normalizedVerticalId) || null;
}

export function buildCanonicalDomainOriginForVertical(verticalId, protocol = "https:") {
  const route = getCanonicalDomainRouteForVertical(verticalId);
  if (!route?.hostname) return "";
  const normalizedProtocol = String(protocol || "https:").trim().replace(/:\/*$/, "");
  return `${normalizedProtocol || "https"}://${route.hostname}`;
}
